<div *ngIf="src.show" class="col-sm-12 text-center">
    <button (click)="toogleContent()" class="ui button mini">
        {{ src.text | translate }}
    </button>
</div>